export default {
  getDataInfo: '/activationScore/client/home',
  firstWatch: '/v3/grow/watch',
  status: '/v3/awardcenter/flexibleTimeTask/status'
}
